import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface HeaderState {
  isSearch: boolean;
  isLogin: boolean;
  isLoginShow: boolean;
  backgroundColor: string | null;
  themeColor: string | null;
  isHeaderVisible: boolean;
  reTriggerNeeded: boolean;
  backBtnDetails: any;
  isAtProfile: boolean;
  profilePageUser: any;
  top?: number;
}

export interface FooterState {
  footerBackgroundColor: string | null;
  footerThemeColor: string | null;
  isFooterVisible: boolean;
  footerClass: string | '';
  showMarketingCtas?: boolean;
}

const DEFAULT_HEADER_STATE: HeaderState = {
  isSearch: true,
  isLogin: false,
  isLoginShow: true,
  backgroundColor: null,
  themeColor: null,
  isHeaderVisible: true,
  reTriggerNeeded: false,
  backBtnDetails: null,
  isAtProfile: false,
  profilePageUser: null
};

const DEFAULT_FOOTER_STATE: FooterState = {
  footerBackgroundColor: null,
  footerThemeColor: null,
  isFooterVisible: true,
  footerClass: 'about-align-footer',
  showMarketingCtas: false
};

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterStateService {
  userData$ = new Subject<any>();
  stateSubject = new BehaviorSubject<HeaderState>({ ...DEFAULT_HEADER_STATE });

  footerStateSubject = new BehaviorSubject<FooterState>({ ...DEFAULT_FOOTER_STATE });

  themeChangeSubject = new Subject<string>();

  // Updating header state
  updateState(state: Partial<HeaderState>) {
    const current = this.stateSubject.value;
    this.stateSubject.next({
      ...current,
      isSearch: state.isSearch !== undefined ? state.isSearch : current.isSearch,
      isLogin: state.isLogin !== undefined ? state.isLogin : current.isLogin,
      isLoginShow: state.isLoginShow !== undefined ? state.isLoginShow : current.isLoginShow,
      backgroundColor: state.backgroundColor !== undefined ? state.backgroundColor : current.backgroundColor,
      themeColor: state.themeColor !== undefined ? state.themeColor : current.themeColor,
      isHeaderVisible: state.isHeaderVisible !== undefined ? state.isHeaderVisible : current.isHeaderVisible,
      reTriggerNeeded: state.reTriggerNeeded !== undefined ? state.reTriggerNeeded : current.reTriggerNeeded,
      backBtnDetails: state.backBtnDetails !== undefined ? state.backBtnDetails : current.backBtnDetails,
      isAtProfile: state.isAtProfile !== undefined ? state.isAtProfile : current.isAtProfile,
      profilePageUser: state.profilePageUser !== undefined ? state.profilePageUser : current.profilePageUser,
      top: state.top !== undefined ? state.top : current.top
    });
  }

  // Updating footer state (callers may pass backgroundColor/themeColor for footer styling)
  updateFooterState(state: Partial<FooterState> & { backgroundColor?: string | null; themeColor?: string | null }) {
    const current = this.footerStateSubject.value;
    this.footerStateSubject.next({
      ...current,
      footerBackgroundColor: state.backgroundColor !== undefined ? state.backgroundColor : current.footerBackgroundColor,
      footerThemeColor: state.themeColor !== undefined ? state.themeColor : current.footerThemeColor,
      isFooterVisible: state.isFooterVisible !== undefined ? state.isFooterVisible : current.isFooterVisible,
      footerClass: state.footerClass !== undefined ? state.footerClass : current.footerClass,
      showMarketingCtas: state.showMarketingCtas !== undefined ? state.showMarketingCtas : (current.showMarketingCtas ?? false)
    });
  }

  emitUserData(data: any) {
    this.userData$.next(data);
  }

  emitThemeChange(theme: string) {
    this.themeChangeSubject.next(theme);
  }
}